/*==================================================
    program name    : 公用函式
    author          : Samma
    last update     : 2020-05-06
    use description : 
==================================================*/
export default {
  //取得 API Server URL
  appGetAPIServerURL: function () {
    return location.protocol + '//' + location.host + '/api/';
  },
  appGetAPIURL: function (name) {
    var resource_name = '';
    switch (name) {
      //廣告播放
      case 'ad':
        resource_name = 'ad';
        break;
      //空櫃查詢
      case 'location':
        resource_name = 'info';
        break;
      //價格查詢
      case 'price':
        resource_name = 'locker';
        break;
      //價格試算
      case 'cal-fee':
        resource_name = 'calc';
        break;
      //據點介紹(地圖)
      case 'loc-map':
        resource_name = 'intro';
        break;
      //據點介紹(圖文模式)
      case 'loc-photo':
        resource_name = 'location';
        break;
      //合作夥伴
      case 'partner':
        resource_name = 'cooperation';
        break;
      //最新消息(summary)
      case 'news_summary':
        resource_name = 'news';
        break;
      //最新消息(detail)
      case 'news_detail':
        resource_name = 'news';
        break;
      //常見問題
      case 'faq':
        resource_name = 'faq';
        break;
      //傳送問題
      case 'send-faq':
        resource_name = 'question';
        break;
    }

    //有指定明確的 api 可用資源時
    if (resource_name && resource_name.length > 0) {
      return this.appGetAPIServerURL() + resource_name;
    } else {
      return null;
    }
  },
  appGetOWLockerDataFromCache: function (url) {
    // CODELAB: Add code to get weather forecast from the caches object.
    if (!('caches' in window)) {
      // return null;
      return Promise.reject('appGetOWLockerDataFromCache() is false');
    }

    return caches
      .match(url)
      .then((response) => {
        if (response) {
          return response.json();
        }
        return null;
        // return Promise.reject('getTodoListFromCache() is fale');
      })
      .catch((err) => {
        console.error('Error getting data from cache', err);
        return null;
        // return Promise.reject('getTodoListFromCache() is fale');
      });
  },
  appGetOWLockerDataFromNetwork: function (url) {
    return fetch(url)
      .then((res) => res.json())
      .then((json) => {
        return json;
      })
      .catch(() => {
        return null;
      });
  },
  //依 UI 需求排列副櫃 (UI 需求 : S / L / M)
  pbLockerTypeSort: function (locker_type) {
    var sort_num = 0;
    switch (locker_type) {
      //手機充電櫃
      case 'M':
        sort_num = 3;
        break;
      //小櫃
      case 'S':
        sort_num = 1;
        break;
      //大櫃
      case 'L':
        sort_num = 2;
        break;
    }
    return sort_num;
  },
  //驗證 email 格式
  pbValidEmail: function (email) {
    var reg = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;
    return reg.test(email);
  },
  //驗證是否為 empty object
  pbIsEmptyObject: function (obj) {
    for (var key in obj) {
      return false;
    }
    return true;
  },
  //補位 - 可指定位數
  pbZeroPadding: function (num, digit) {
    var zero = '';
    for (var i = 0; i < digit; i++) {
      zero += '0';
    }
    return (zero + num).slice(-digit);
  },
  //取得既定格式的時間戳記 => yyyy-mm-dd h24:mi
  pbGetCurrentDateTimeNoSec: function (date_separate_char, time_separate_char) {
    if (!date_separate_char) {
      date_separate_char = '-';
    }
    if (!time_separate_char) {
      time_separate_char = ':';
    }
    var d = new Date();
    return (
      d.getFullYear() +
      date_separate_char +
      this.pbZeroPadding(d.getMonth() + 1, 2) +
      date_separate_char +
      this.pbZeroPadding(d.getDate(), 2) +
      ' ' +
      this.pbZeroPadding(d.getHours(), 2) +
      time_separate_char +
      this.pbZeroPadding(d.getMinutes(), 2)
    );
  },
  //取得既定格式的時間戳記 => yyyy-mm-dd h24:mi
  pbGetSpecifiedDateTimeNoSec: function (
    datetime,
    date_separate_char,
    time_separate_char
  ) {
    if (!date_separate_char) {
      date_separate_char = '-';
    }
    if (!time_separate_char) {
      time_separate_char = ':';
    }
    return (
      datetime.getFullYear() +
      date_separate_char +
      this.pbZeroPadding(datetime.getMonth() + 1, 2) +
      date_separate_char +
      this.pbZeroPadding(datetime.getDate(), 2) +
      ' ' +
      this.pbZeroPadding(datetime.getHours(), 2) +
      time_separate_char +
      this.pbZeroPadding(datetime.getMinutes(), 2)
    );
  },
  //取得既定格式的時間戳記 => yyyy-mm-dd
  pbGetCurrentDate: function (separate_char) {
    var d = new Date();
    return (
      d.getFullYear() +
      separate_char +
      this.pbZeroPadding(d.getMonth() + 1, 2) +
      separate_char +
      this.pbZeroPadding(d.getDate(), 2)
    );
  },
};
